import React from 'react';
import ApkAssignmentState from './apkAssignmentState/ApkAssignmentState';
import ApkSection from './components/ApkSection/ApkSection';
import RestaurantsSection from './components/RestaurantsSection/RestaurantsSection';
import { ModalWindows } from './components/ModalWindows';
import style from './index.module.scss';

const ApkAssignmentPage: React.FC = () => {
	return (
		<ApkAssignmentState>
			<div className={style.container}>
				<ApkSection />
				<RestaurantsSection />
			</div>
			<ModalWindows />
		</ApkAssignmentState>
	);
};

export default ApkAssignmentPage;
